// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3Mxpx","tab":"Tabs_tab__2Bk4P","tabActive":"Tabs_tabActive__2waCh"};